<script lang="ts" setup>
  import { useNotifications } from '@/shared/lib'

  import { type ProductOutFull, getProduct } from '@/entities/shop'

  import { SHOP_MANAGEMENT_URL, SHOP_USER_URL, ShopItemEditor } from '@/features/shop/editItem'

  definePage({
    meta: {
      layout: 'baseNew',
      shopManagerRoute: true,
    },
  })

  const { t } = useI18n()
  const { errorNotification } = useNotifications()
  const route = useRoute('/shop/item/[id]/edit/')
  const router = useRouter()

  const fromPath = history.state?.from

  useHead({
    title: t('shop_edit_item_page_title'),
  })

  const loadedProduct = ref<ProductOutFull | null>(null)

  const productId = computed(() => Number(route.params.id))

  const { data, error, response } = await getProduct(productId.value)

  const isNotFound = error && response?.status === 404
  const isDeleted = data?.is_deleted

  if (isNotFound || isDeleted || !data) {
    await router.replace({ name: SHOP_USER_URL })
    errorNotification('shop_item_not_found')
  } else {
    loadedProduct.value = data
  }

  const redirectBackToPage = () => {
    if (fromPath === SHOP_MANAGEMENT_URL) {
      router.push(SHOP_MANAGEMENT_URL)
      return
    }

    if (loadedProduct.value?.id) {
      router.push({ name: `${SHOP_USER_URL}item/[id]/`, params: { id: loadedProduct.value.id } })
    } else {
      router.push({ name: SHOP_USER_URL })
    }
  }
</script>

<template>
  <ShopItemEditor
    v-if="loadedProduct"
    mode="edit"
    :item="loadedProduct"
    @saved="redirectBackToPage"
    @cancel="redirectBackToPage"
    @submit-failed="redirectBackToPage"
  />
</template>
